import { createClient } from '@supabase/supabase-js';

var url = process.env.REACT_APP_SUPABASE_URL;
var key = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !key) {
  console.error('Supabase keys missing - check .env.local and restart the dev server.');
}

export var supabase = (url && key) ? createClient(url, key) : null;